<template>
  <div class="labeled-vehicles-list">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <VehicleType
      ref="vehicleType"
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :is-disabled="isDisabled"
      :vehicle-types="vehicleTypes"
      :empty-state-text="emptyStateText"
      @beforeChange="onBeforeChange"
      v-on="$listeners"
      v-bind="$attrs"
    >
      <slot />
    </VehicleType>
  </div>
</template>

<script>
import VehicleType from '../vehicle-type';
import { RandomId } from '@/shared/lib/random';
import { InputLabel } from '@/shared/ui/form';

const { generateRandomId } = RandomId();

export default {
  props: {
    value: {
      type: [String, Object],
      default: null,
    },
    label: {
      type: String,
      default: 'Оберіть авто клієнта зі списку',
    },
    placeholder: {
      type: String,
      default: 'Виберіть тип транспортного засобу',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    vehicleTypes: {
      type: Array,
      default: () => [],
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    emptyStateText: {
      type: String,
      default: 'Нічого немає',
    },
  },
  data() {
    return {
      inputId: `vehicle-type-${this.generateRandomId()}`,
    };
  },
  components: { InputLabel, VehicleType },
  computed: {
    getVehicleTypeSelect() {
      return this.$refs.vehicleType;
    }
  },
  methods: {
    generateRandomId,
    onBeforeChange(newValue, oldValue) {
      this.$emit('beforeChange', newValue, oldValue);
    }
  },
};
</script>
